module.exports = __webpack_public_path__ + "img/upper_pocket_bag_height.cc5af427.png";